import React from "react";
import BCMSWebAgent from "../../classes/BCMSWebAgent/";
import "./styles.css";

// Disclaimer that's shown if client has "watermark" set in backend:
export default function BCMSDisclaimer(props) {

  // Generate cookie for 24 hours and reloads page if user "agrees" with TOS:
  const onAgree = (evt) => {
    // Saves for 24 hours:
    let date = new Date();
    let expiration = date.setTime(date.getTime()+(24*60*60*1000));
    BCMSWebAgent.setCookie("beavercreekDisclaimer", "true", date.toUTCString());
    // Force page reload:
    window.location.reload(true);
  }

  // Redirects to bcm.io if user "disagrees" with TOS:
  const onDisagree = (evt) => {
    if(window.self != window.top) {
      parent.window.location = 'https://bcm.io/';
    }else{
      window.location = 'https://bcm.io/';
    }
  }

  // Returns current year:
  const getYear = () => {
    let date = new Date();
    return date.getFullYear();
  }

  return (
    <div className="disclaimerPrompt">
    <div className="overlay"></div>
    <div className="content">
      <header>Beavercreek Marketing Terms And Conditions</header>
      <section>
        <p>Viewing this Click-Thru Demonstration is governed by the following Terms and Conditions:</p>
        <ul>
          <li>This online content is for demonstration purposes to be used only by Fiserv and authorized Fiserv affiliates.</li>
          <li>This demo is not to be used, or linked to, by financial institutions for the purpose of staff training or public use.</li>
          <li>To subscribe to a fully branded version of this demo, contact Beavercreek Marketing at info@bankall.com.</li>
          <li>The Click-Thru Demonstration is Copyright © <span>{getYear()}</span> by Beavercreek Inc. All rights reserved.</li>
        </ul>
        </section>
        <footer>
          <button className="button agree" onClick={onAgree}>I agree</button>
          <button className="button disagree" onClick={onDisagree}>I disagree</button>
        </footer>
    </div>
  </div>
  );
}

// :: VOID ->  BOOLEAN
// Returns BOOLEAN for if user has "agreed" to TOS:
export function hasAgreed() {
  return BCMSWebAgent.getCookieValue('beavercreekDisclaimer');
}
